import { render } from "./my-order-details.vue?vue&type=template&id=5872288a&scoped=true"
import script from "./my-order-details.vue?vue&type=script&lang=js"
export * from "./my-order-details.vue?vue&type=script&lang=js"

import "./my-order-details.vue?vue&type=style&index=0&id=5872288a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5872288a"]])

export default __exports__